import { Component, OnInit, Inject, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-attach-file-dialog-view-picture',
  templateUrl: './attach-file-dialog-view-picture.component.html'
})
export class DialogViewPictureComponent implements OnInit {

  // #region input
  @Input() label: string;
  @Input() imageSrc: string; 
  //#endregion

  // #region output
  @Output() fileSource = new EventEmitter<any>();
  //#endregion

  path: any
  urlImg: string;
  files: any;
  // data :any
  // convenience getter for easy access to form fields

  constructor(
    public dialogRef: MatDialogRef<DialogViewPictureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (this.data && this.data.url) {
      this.urlImg = environment.apiUrl + `files/${this.data.url}`;
    }
    if(this.imageSrc){
      this.urlImg = environment.apiUrl + `files/${this.imageSrc}`; 
    } 
    
  }
  onNoClick() {
    this.dialogRef.close()
  }
  /**
   * 
   * @param event thông tin file tải lên
   */
  onFileChange(event) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.files = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.urlImg = this.imageSrc;
        this.fileSource.emit({
          source: reader.result,
          files: this.files
        });
      };

    }
  }
}
